import qs from 'qs';
import { HttpMethods } from "../enums/HttpMethods";
import ContentPieceDTO from '../DTOs/ContentPieceDTO';
import { Filters } from "../interfaces/Filters";
import ContentFeedService from "./contentFeed.service";
import { DataWrapper } from "../interfaces/DataWrapper";
import { ContentPiece } from "../interfaces/ContentPiece";

const descendingOrder = 'desc';
const includeAllRelations = 'populate=site,language,storie,type,tags,raw_input,variation_content_pieces.site,variation_content_pieces.language,stories';

class ArticlesService {
  public static getById(id: string): Promise<ContentPieceDTO> {
    return ContentFeedService.sendRequest<DataWrapper<ContentPiece>>(
      HttpMethods.GET,
      `content-pieces/${id}?${includeAllRelations}`
    )
      .then((wrappedRawContent: DataWrapper<ContentPiece>) => {
        return new ContentPieceDTO(wrappedRawContent.data);
      })
      .catch((error: Error) => {
        throw error;
      });
  }

  public static getFilteredWithPagination(
    pageStart: number,
    paginationLimit: number,
    filters: Filters
  ): Promise<ContentPieceDTO[]> {
    let query = '';

    if (filters.hasWords) {
      const words = filters.hasWords.split(' ');
      const andConditions = words.map(word => ({
        $or: [
          { headlines_english: { $containsi: word } },
          { processed_content: { $containsi: word } }
        ]
      }));

      query += '&' + qs.stringify({
        filters: {
          $and: andConditions
        },
      });
    }

    filters.types.forEach((type) => {
      query += '&' + qs.stringify(
        {
          filters: {
            type: {
              id: { $eq: type.id }
            }
          }
        }
      );
    })

    filters.sites.forEach((site) => {
      query += '&' + qs.stringify(
        {
          filters: {
            site: {
              id: { $eq: site.id }
            }
          }
        }
      );
    })

    if (filters.tags.length > 0) {
      query += '&' + qs.stringify(
        {
          filters: {
            $and: filters.tags.map((tag) => {
              return {
                tags: {
                  id: { $in: tag.id }
                }
              }
            })
          },
        }
      );
    }

    if (filters.date) {
      query += '&' + qs.stringify(
        {
          filters: {
            $and: [
              {
                postCreatedAt: { $gte: filters.date.start },
              },
              {
                postCreatedAt: { $lte: filters.date.end }
              }
            ]
          }
        }
      );
    }

    if (filters.author) {
      query += '&' + qs.stringify(
        {
          filters:
          {
            author: { $eq: filters.author }
          }
        }
      );
    }

    if (null !== filters.hasTips) {
      if (filters.hasTips) {
        query += '&' + qs.stringify(
          {
            filters: {
              $and: [
                {
                  tips_and_predictions: { $notNull: true },
                },
                {
                  tips_and_predictions: { $ne: '' }
                }
              ]
            }
          }
        );
      } else {
        query += '&' + qs.stringify(
          {
            filters: {
              $or: [
                {
                  tips_and_predictions: { $null: filters.hasTips },
                },
                {
                  tips_and_predictions: { $eq: '' }
                }
              ]
            }
          }
        );
      }
    }

    query += '&' + qs.stringify(
      {
        sort: { postCreatedAt: descendingOrder },
        pagination: {
          page: pageStart,
          pageSize: paginationLimit,
        },
      },
      { encodeValuesOnly: true }
    );

    return ContentFeedService.sendRequest<DataWrapper<ContentPiece[]>>(
      HttpMethods.GET,
      `content-pieces?${query}&${includeAllRelations}`
    )
      .then((wrappedRawContents: DataWrapper<ContentPiece[]>) =>
        ContentPieceDTO.mapContentPieces(wrappedRawContents.data)
      )
      .catch((error: Error) => {
        throw error;
      });
  }
}

export default ArticlesService;